import React, { FC, useCallback } from 'react';
import { Box, Spinner } from '@chakra-ui/react';

import { useApi, useFetchData } from '@app/hooks';
import { EquipmentRepairOrder } from '@app/api/models';
import { API_FEAT_DATE_FORMAT } from '@app/utils';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';

import { useColumns } from './columns';
import { QueryTable } from '../common/table';
import { useFilterState } from './hooks/use-filter-state';
import { RepairsFilter } from './components/repairs-filter';

const EquipmentsRepairTable: FC = () => {
  const { 
    isLoading, 
    statuses,
    selectedStatuses,
    setSelectedStatuses,
    period,
    setPeriod,
  } = useFilterState();

  const canCheckStatusEdit = usePermissions({
    roles: [ROLES.CHIEF, ROLES.MANAGER],
  });

  const api = useApi();

  const [fetchData] = useFetchData<EquipmentRepairOrder>({ method: api.equipments.getEquipmentsRepairs });
  const columns = useColumns({
    canCheckStatusEdit
  });

  const fetch = useCallback((params) => {
    if (isLoading) {return Promise.resolve({ data: [], total: 0 });}
    return fetchData({
      ...params, filterRaw: {
        ...params.filterRaw,
        status_id: selectedStatuses?.length > 0 ? selectedStatuses.map(({ id }) => Number(id)) : undefined,
        create_date_range: period ? [period.startDate.format(API_FEAT_DATE_FORMAT), period.endDate.format(API_FEAT_DATE_FORMAT)] : undefined
      }
    });
  }, [fetchData, selectedStatuses, period, isLoading]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <QueryTable<EquipmentRepairOrder>
        title="Заявки на сервис"
        secondaryToolbar={<RepairsFilter
          statuses={statuses}
          selectedStatuses={selectedStatuses}
          setSelectedStatuses={setSelectedStatuses}
          period={period}
          setPeriod={setPeriod}
        />}
        columns={columns}
        fetchData={fetch}
        canDownload
      />
    </>
  );
};

export default EquipmentsRepairTable;
